module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_unify_information-7b46b45754a72759f0a81c72267b6679.png";